import { axiosInstance } from "../../utils/axios";
import { Scenario } from "../models/scenario";

export async function fetchReferringScenarios(dbId: string, dimensionOid: string): Promise<Scenario> {
  const response = await axiosInstance.get(`/scenario/${dbId}/${dimensionOid}`);
  return response.data;
}
